import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ico_Close",
  "use": "ico_Close-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"ico_Close\">\n    <path data-name=\"Union 11\" d=\"m12 12.708-5.305 5.3-.707-.707 5.306-5.3-5.3-5.305.707-.706 5.3 5.305 5.305-5.3.706.707-5.3 5.3 5.3 5.3-.707.707z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol